module.exports = __webpack_public_path__ + "img/text-title.49fd2734.webp";